<template>
  <div class="l-container c-help--authCallback">
    <div class="l-container--inner">
      <!-- This is only briefly displayed to the user following a login -->
      <load-indicator request="signin-oidc" />
    </div>
  </div>
</template>

<script>
import logger from '../utilities/logger'
import LoadIndicator from '../components/LoadIndicator.vue'

export default {
  name: 'AuthCallback',
  components: {
    LoadIndicator
  },
  async mounted() {
    // Redirect the user to the your main page
    const { VUE_APP_PUBLIC_PATH } = process.env
    const urlParams = new URLSearchParams(window.location.search)
    let returnUrl = urlParams.get('returnUrl')

    // If returnUrl is null or empty, default to the public path
    if (returnUrl === null || returnUrl === '') {
      returnUrl = `${window.location.origin}${VUE_APP_PUBLIC_PATH}`
    }

    // Log a warning if the returnUrl does not include the Help path
    if (!returnUrl.includes(VUE_APP_PUBLIC_PATH)) {
      logger.warn(`External return path: ${returnUrl}`)
    }

    try {
      await this.$auth.handleCallback()
    } catch (error) {
      logger.error('Authentication failed', error)
      // Optionally handle the error, e.g., show a message to the user
    } finally {
      window.location.href = returnUrl
    }
  }
}
</script>
